"use client";

import { useAtom } from "jotai";
import { useParams } from "next/navigation";
import { settingsAtom } from "../atoms/settings.atom";
import { useEffect } from "react";

const useProjectId = () => {
  const { id } = useParams();
  const [settings, setSettings] = useAtom(settingsAtom);

  useEffect(() => {
    if (!!id && settings.currentProject !== id) {
      setSettings((prev) => ({ ...prev, currentProject: id as string }));
    }
  }, [id, settings.currentProject, setSettings]);

  return id as string;
};

export default useProjectId;
